import { render, staticRenderFns } from "./templates-add.vue?vue&type=template&id=d9711cee&scoped=true"
import script from "./templates-add.vue?vue&type=script&lang=js"
export * from "./templates-add.vue?vue&type=script&lang=js"
import style0 from "./templates-add.vue?vue&type=style&index=0&id=d9711cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9711cee",
  null
  
)

export default component.exports